export enum JitsuEvent {
  QUESTION_BOOKMARKED = "Question Bookmarked",
  QUESTION_SKIPPED = "Question Skipped",
  EDITOR_PASTED = "Editor Pasted",
  EDITOR_HISTORY_CHANGED = "Editor History Changed",
  RESOURCE_VIEWED = "Resource Viewed",
  MANUAL_VIEWED = "Manual Viewed",
  QUESTION_OPENED = "Question Opened",
  ANSWER_WORD_LIMIT_EXCEEDED = "Answer Word Limit Exceeded",
  BROWSER_CONNECTION_RESTORED = "Browser Connection Restored",
  FEEDBACK_VIEWER_OPENED = "Feedback Viewer Opened",
  FEEDBACK_VIEWER_TIME_SPENT = "Feedback Viewer Time Spent",
  CHARTER_OPENED = "Charter Opened",
  GROUP_TASK_CREATED = "Group Task Created",
  GROUP_TASK_UPDATED = "Group Task Updated",
  GROUP_TASK_DELETED = "Group Task Deleted",
  PEER_EVALUATION_OPENED = "Peer Evaluation Opened",
  WORK_OPENED = "Work Opened",
  VIDEO_RESPONSE_PREPARATION_SKIPPED = "Video Response Preparation Skipped",
  VIDEO_RESPONSE_REMAINING_TIME_SKIPPED = "Video Response Remaining Time Skipped",
  VIDEO_RESPONSE_TIME_ELAPSED = "Video Response Time Elapsed",
  VIDEO_RESPONSE_REVIEWED = "Video Response Reviewed",
  VIDEO_RESPONSE_ATTEMPT_FORFEITED = "Video Response Attempt Forfeited",
  VIDEO_RESPONSE_ATTEMPT_SELECTED = "Video Response Attempt Selected",
  VIDEO_RESPONSE_FAILED = "Video Response Failed",
  VIDEO_RESPONSE_PREPARATION_MEDIA_RECORD_FAILED = "Video Response Preparation Media Record Failed",
  DEVICE_CHECK_OPENED = "Device Check Opened",
  DEVICE_CHECK_MEDIA_FAILED = "Device Check Media Failed",
  DEVICE_CHECK_PASSED_WITH_SILENT_MICROPHONE = "Device Check Passed With Silent Microphone",
  STUDENT_ACTION_SHOWN = "Student Action Shown",
  STUDENT_ACTION_CLICKED = "Student Action Clicked",
  STUDENT_ACTIONS_EMPTY = "Student Actions Empty",
  GROUP_CHANGE_REQUEST_SENT = "Group Change Request Sent",
  GROUP_CHANGE_REQUEST_UPDATED = "Group Change Request Updated",
  GROUP_CHANGE_REQUEST_WITHDRAWN = "Group Change Request Withdrawn",
}
